import { ArrowRight, FileText, Scale } from 'lucide-react';
import { Link } from 'react-router-dom';
import { PageHero } from '../components/Sections';
import { canonicalLegalLinks, legalDocuments, policyMeta } from '../legalContent';

const keysByPath = Object.fromEntries(Object.keys(legalDocuments).map((key) => [`/${key}`, key]));

export function LegalHub() {
  return (
    <>
      <PageHero
        eyebrow="Public legal centre"
        title="Clear rules for every Sawwari journey."
        text={`Current public policies for Sawwari users and Captains in Pakistan. Version ${policyMeta.version}, effective ${policyMeta.effectiveDate}.`}
        tone="ink"
      />
      <section className="section">
        <div className="container legal-hub-grid">
          {canonicalLegalLinks.map(([label, path]) => {
            const document = legalDocuments[keysByPath[path]];
            return (
              <article key={path}>
                <span><FileText /></span>
                <h2>{label}</h2>
                <p>{document.summary}</p>
                <Link className="text-link" to={path}>Read policy <ArrowRight size={17} /></Link>
              </article>
            );
          })}
        </div>
      </section>
      <section className="section section--soft">
        <div className="container compact-trust__inner">
          <Scale />
          <div><span className="eyebrow">Law and local authorization</span><h2>Pakistan-wide platform. Service activated only where locally permitted.</h2><p>Sawwari coverage remains subject to the applicable transport, vehicle, tax, safety and law-enforcement requirements of each province or territory.</p></div>
          <Link className="button button--secondary" to="/complaints">Complaints policy</Link>
        </div>
      </section>
    </>
  );
}
